import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import * as AdsActionCreators from '../../redux/homepageAds';
import ImageUploader from 'react-images-upload';

const ImageWrraper = styled.div`
  > img {
    height: 200px;
  }
`;

class AdsEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pictures: [],
      showOnHomepage: true,
      displayAtHomeField: false,
      linkField: '',
      descriptionField: '',
      orderField: 1,
      imageUrl: null
    };
    this.onDrop = this.onDrop.bind(this);
  }

  onDrop(pictureFiles, pictureDataURLs) {
    this.setState({
      pictures: pictureFiles
    });
  }
  async saveImage(adId, file, type) {
    const { actions } = this.props;

    const formData = new FormData();
    formData.append('image', file);
    formData.append('type', type);

    try {
      await actions.uploadAdImage(adId, formData);
    } catch (e) {
      throw e;
    }
  }
  async componentDidMount() {
    const {
      actions,
      match: { params }
    } = this.props;
    if (params.id) {
      await actions.getAd(params.id);
      const { ad } = this.props;
      this.setState({
        orderField: ad.order,
        linkField: ad.link,
        descriptionField: ad.description,
        showOnHomepage: !ad.archived,
        imageUrl: ad.image_url
      });
    }
  }
  async uploadAd() {
    const { actions, ad, history } = this.props;
    if (
      this.state.orderField &&
      this.state.linkField &&
      this.state.descriptionField
    ) {
      if (ad.id) {
        await actions.updateAd(ad.id, {
          order: this.state.orderField,
          link: this.state.linkField,
          description: this.state.descriptionField,
          archived: !this.state.showOnHomepage
        });
        if (this.state.pictures.length) {
          await this.saveImage(ad.id, this.state.pictures[0], 'cover');
        }
      } else {
        const adAdded = await actions.createAd({
          order: this.state.orderField,
          link: this.state.linkField,
          description: this.state.descriptionField,
          archived: !this.state.showOnHomepage
        });
        if (this.state.pictures.length) {
          await this.saveImage(adAdded.id, this.state.pictures[0], 'cover');
        }
      }
      history.push('/ads');
    }
  }

  onChangeSwitch = fieldName => (e, checked) =>
    this.setState({ [fieldName]: checked });

  onChangeLinkUrl = value => this.setState({ linkField: value });

  onChangeDescription = value => this.setState({ descriptionField: value });

  onChangeOrder = value => this.setState({ orderField: value });

  render() {
    const { imageUrl, showOnHomepage } = this.state;
    return (
      <div>
        <div>
          Show Ad on Home Page
          <Switch
            checked={showOnHomepage}
            onChange={this.onChangeSwitch('showOnHomepage')}
          />
          <div>
            <TextField
              value={this.state.linkField}
              id="link"
              label="Link URL"
              type="text"
              margin="normal"
              onChange={e => this.onChangeLinkUrl(e.target.value)}
              onKeyPress={this.onEnter}
            />
          </div>
          <div>
            <TextField
              value={this.state.descriptionField}
              id="description"
              label="Description"
              type="text"
              margin="normal"
              onChange={e => this.onChangeDescription(e.target.value)}
              onKeyPress={this.onEnter}
            />
          </div>
          <div>
            <TextField
              value={this.state.orderField}
              id="order"
              label="Order"
              type="number"
              margin="normal"
              onChange={e => this.onChangeOrder(e.target.value)}
              onKeyPress={this.onEnter}
            />
          </div>
          {imageUrl && (
            <ImageWrraper>
              <img alt="" src={this.state.imageUrl} />
            </ImageWrraper>
          )}
          <ImageUploader
            withIcon={true}
            buttonText="Choose images"
            onChange={this.onDrop}
            imgExtension={['.jpg', '.gif', '.png', '.gif']}
            maxFileSize={5242880}
            withPreview={true}
          />
          <div style={{ marginTop: '10px' }}>
            <Button
              onClick={() => this.uploadAd()}
              variant="raised"
              component="span"
            >
              Save Ad
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ad: state.homepageAds.ad
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AdsActionCreators, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AdsEditPage)
);



// WEBPACK FOOTER //
// ./src/pages/ads/edit.js